// extracted by mini-css-extract-plugin
export default {"title":"NewPassword_title__JRgNe","inputWrapper":"NewPassword_inputWrapper__nPX4j","text":"NewPassword_text__H36Aa"};